/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createValidationProblemDetailsFromDiscriminatorValue, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Dashboard/VerifyByFile
 */
export interface VerifyByFileRequestBuilder extends BaseRequestBuilder<VerifyByFileRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(requestConfiguration?: RequestConfiguration<VerifyByFileRequestBuilderPostQueryParameters> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<VerifyByFileRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface VerifyByFileRequestBuilderPostQueryParameters {
    bookingNumber?: string;
    passengerDataFileId?: number;
}
/**
 * Uri template for the request builder.
 */
export const VerifyByFileRequestBuilderUriTemplate = "{+baseurl}/Dashboard/VerifyByFile?bookingNumber={bookingNumber}&passengerDataFileId={passengerDataFileId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const VerifyByFileRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: VerifyByFileRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
};
/* tslint:enable */
/* eslint-enable */
